const NoDataRow = ({ colSpan, message, tdClassName = "", alertClassName = "" }) => {
    return (
        <tr>
            <td
                colSpan={colSpan}
                className={`p-0 ${tdClassName}`}
            >
                <div className={`alert alert-info-sub p-2 h6 text-center m-0 bg-[#f5f5f5]! ${alertClassName}`}>
                    {message}
                </div>
            </td>
        </tr>
    )
};

export default NoDataRow;